export default __webpack_public_path__ + "static/media/plus-circle-inactive.f2f561b3.svg";